:host {
  display: block;
}

dnn-dropzone{
  min-width: 65vw;
}